import React from 'react';

const DivRow = ({ width = 'auto', children, className='' }) => {

    if(width === 'auto'){
        width = `${parseInt(100/children.length)}%`
    }

    return (
        <div style={{ width }}>
            <div className={`step-container ${className}`}>
                {children}
            </div>
        </div>
    );
}

export default DivRow;
